import { CardProps } from '@material-ui/core';
import { useApiEffect } from 'framework/hooks/useApiEffect';
import { useLazyEffect } from 'framework/hooks/useLazyEffect';
import { IPatientDetail, salesQuery_byPatientX } from 'gen/ApiClient';
import React from 'react';
import { IReloadTriggerProps } from 'shared/layout/IReloadTriggerProps';
import { SalesByPatientCard } from './SalesByPatientCard';

interface IProps extends IReloadTriggerProps, CardProps {
	item: IPatientDetail;
	reload: VoidFunction;
}

export const SalesByPatientOverviewCard = ({ item, reloadTrigger, reload, ...rest }: IProps) => {
	const [data, reloadSales] = useApiEffect(salesQuery_byPatientX, item.patient.id);

	useLazyEffect(() => {
		reloadSales();
	}, [reloadTrigger]);

	if (data === undefined) {
		return <></>;
	}

	return (
		<SalesByPatientCard
			data={data}
			reload={reload}
			hasLinkedCustomerAccount={item.hasCustomerAccount}
			{...rest}
		/>
	);
};
